var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime18 = function SvgTime18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0m0 16.2A7.2 7.2 0 1 1 9 1.8a7.2 7.2 0 0 1 0 14.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.602 8.1h-2.7V5.4a.9.9 0 0 0-1.8 0V9a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 0-1.8"
  })));
};
export default SvgTime18;